import { useCallback, useRef } from 'react'

import {
  CLICK_DURATION_MS,
  CLICK_VS_DRAG_DISTANCE_PX,
} from '@/features/annotation/constants'

export const useClickDetection = () => {
  const mouseDownRef = useRef<{
    x: number
    y: number
    time: number
  } | null>(null)

  const handleMouseDown = useCallback(
    (event: React.MouseEvent<HTMLDivElement>) => {
      mouseDownRef.current = {
        x: event.clientX,
        y: event.clientY,
        time: Date.now(),
      }
    },
    []
  )

  const isActualClick = useCallback(
    (event: React.MouseEvent<HTMLDivElement>): boolean => {
      const mouseDown = mouseDownRef.current
      const isClick =
        !mouseDown ||
        (Math.abs(event.clientX - mouseDown.x) < CLICK_VS_DRAG_DISTANCE_PX &&
          Math.abs(event.clientY - mouseDown.y) < CLICK_VS_DRAG_DISTANCE_PX &&
          Date.now() - mouseDown.time < CLICK_DURATION_MS)

      mouseDownRef.current = null
      return isClick
    },
    []
  )

  return {
    handleMouseDown,
    isActualClick,
  }
}
